export default __webpack_public_path__ + "static/media/AdminRole_InformationArchitecture_Thumbnail.c4902d82.png";